<script>
  import S1PackageTable from "./S1PackageTable.svelte";
  import { useParams } from "svelte-navigator";
  import { fetchS1PackageData } from "../../utils/getData";
  import { onMount } from "svelte";

  const params = useParams();
  const projectId = $params.project;

  let rawData = undefined;
  let tableData = undefined;
  let specData = undefined;
  let sequenceData = undefined;

  let headerData = undefined;

  onMount(async () => {
    rawData = await fetchS1PackageData(projectId);

    const specs = rawData.Specs;
    const orders = rawData.Orders;
    const results = rawData.Results;
    sequenceData = results.sequence;

    const nOrders = orders.length;
    specData = specs.reduce(
      (acc, multiPropertySpec) =>
        acc.concat(
          multiPropertySpec.Properties.filter(
            (specProperty) => specProperty.Spec_Leveling == 1
          ).reduce((multiPropertyAcc, specProperty) => {
            multiPropertyAcc.push({
              Referring: multiPropertySpec.DisplayString,
              DisplayString:
                specProperty.Spec_Code == "あり" ||
                specProperty.Spec_Code == "なし"
                  ? multiPropertySpec.DisplayString
                  : [multiPropertySpec.DisplayString, specProperty.Spec_Code],
              SpecifiedProperty: specProperty.Spec_Code,
            });
            return multiPropertyAcc;
          }, [])
        ),
      []
    );

    const nSpecs = specData.length;

    tableData = Array.from({ length: nSpecs }, () =>
      new Array(nOrders).fill(false)
    );

    orders.forEach((order, iOrder) => {
      specData.forEach((spec, iSpec) => {
        if (
          spec.Referring &&
          order?.[spec.Referring] == spec.SpecifiedProperty
        ) {
          tableData[iSpec][order.Order_InputSequenceNumber - 1] = true;
        }
      });
    });

    headerData = {
      title: `${results.ExecTime} 投入順平準化 （正常終了）`,
      iterations: results.IterativeCount,
      time: results.ExecDuration,
      orders: results.OrderCount,
    };
  });
</script>

<main>
  {#if headerData}
    <div class="header">
      <h1>{headerData.title}</h1>
      <div
        style="display: flex; justify-content: space-between; align-items: center;"
      >
        <div style="font-weight: bold;">
          反復回数 {headerData.iterations}回 {headerData.time}秒 オーダ{headerData.orders}件
        </div>
        <div class="legend-container">
          <div class="label-row">
            <span>間隔が均等</span>
            <span>間隔が近すぎ/遠すぎ</span>
          </div>
          <div class="color-row">
            <div class="color-block" />
            <div class="color-block" />
            <div class="color-block" />
            <div class="color-block" />
            <div class="color-block" />
          </div>
        </div>
      </div>
    </div>
  {/if}
  <div style="max-width: 100%; overflow-x: scroll; padding-bottom: 1rem">
    <S1PackageTable {tableData} {specData} {sequenceData} />
  </div>
</main>

<style>
  main {
    padding-top: 1rem;
  }
  .header {
    margin-bottom: 1rem;
    text-align: center;
    border: solid;
    position: sticky;
    left: 1vw;
    width: 100%;
    z-index: 100;
    background-color: white;
  }

  .header h1 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .header span {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: bold;
  }

  .legend-container {
    width: 30vw;
  }

  .label-row {
    display: flex;
    justify-content: space-between;
  }

  .color-row {
    display: flex;
    height: 20px;
  }

  .color-block {
    flex: 1;
  }

  .color-block:nth-child(1) {
    background-color: #4dbaa8;
  }
  .color-block:nth-child(2) {
    background-color: #6edaab;
  }
  .color-block:nth-child(3) {
    background-color: #fce65d;
  }
  .color-block:nth-child(4) {
    background-color: #ffb729;
  }
  .color-block:nth-child(5) {
    background-color: #fb5236;
  }
</style>
